export default import.meta.ROLLDOWN_FILE_URL_2ZCqq_IxPuC3uZYm3g37uA